// extracted by mini-css-extract-plugin
export var chevron = "_lp-2";
export var chevronRotated = "_lp-3";
export var header = "_lp-1";
export var section = "_lp-0";